// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Vpt2X","content":"styles_content__1yQL8"};